import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { WindorefService } from '../../services/window/windoref.service';
import { StoragePermissionService } from 'src/app/services/storagePermission/storage-permission.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalsService {
  constructor(
    private _Cookie: CookieService,
    private _http: HttpClient,
    private winRef: WindorefService,
    private _storagePermissionService: StoragePermissionService
  ) {}

  getAffiliateCookies(): any {
    let affOBJ: any = [];
    let POSTAff2Cookie: any = this._Cookie.get('POSTAff2Cookie');
    if (POSTAff2Cookie !== '' && POSTAff2Cookie !== 'undefined') {
      affOBJ.cookies = this._Cookie.get('POSTAff2Cookie');
      if (this._Cookie.get('POSTAff2Data4') !== '') {
        affOBJ.cookies_data1 = this._Cookie.get('POSTAff2Data4');
      }
      if (this._Cookie.get('POSTAff2Data5') !== '') {
        affOBJ.cookies_data2 = this._Cookie.get('POSTAff2Data5');
      }
      if (this._Cookie.get('POSTAff2Data6') !== '') {
        affOBJ.cookies_data3 = this._Cookie.get('POSTAff2Data6');
      }
      if (this._Cookie.get('POSTAff2Track') !== '') {
        affOBJ.track = this._Cookie.get('POSTAff2Track');
      }
      if (this._Cookie.get('POSTCke1TrackId') !== '') {
        affOBJ.cakecookie = this._Cookie.get('POSTCke1TrackId');
      }
    }
    return affOBJ;
  }

  getDataFromParams(): any {
    let paramOBJ: any = [];
    const urlParams = new URLSearchParams(this.winRef.getNativeWindow().location.search);
    if (urlParams.get('utm_source') !== null) {
      paramOBJ.utm_source = urlParams.get('utm_source');
    }
    if (urlParams.get('utm_campaign') !== null) {
      paramOBJ.utm_campaign = urlParams.get('utm_campaign');
    }
    if (urlParams.get('utm_medium') !== null) {
      paramOBJ.utm_medium = urlParams.get('utm_medium');
    }
    if (urlParams.get('utm_content') !== null) {
      paramOBJ.utm_content = urlParams.get('utm_content');
    }
    if (urlParams.get('utm_term') !== null) {
      paramOBJ.utm_term = urlParams.get('utm_term');
    }
    return paramOBJ;
  }

  checkDirectOrganic(paramOBJ, affOBJ): any {
    if (paramOBJ.utm_source === undefined || paramOBJ.utm_source === null) {
      if (affOBJ.cookies === undefined || affOBJ.cookies === null || affOBJ.cookies === '') {
        const site_source = this._Cookie.get('site_source');
        if (site_source !== 'direct' && site_source !== 'external' && site_source !== undefined && site_source !== null) {
          paramOBJ.utm_source = this._Cookie.get('site_source');
          paramOBJ.utm_medium = 'organic';
        } else {
          paramOBJ.utm_source = '';
          paramOBJ.utm_medium = 'direct';
        }
      }
    }
    return paramOBJ;
  }

  getIPAddress() {
    return this._http.get('https://api.ipify.org/?format=json');
  }

  getFormattedLang(lang: string): string {
    switch (lang) {
      case 'es':
        lang = 'es-la';
        break;
      case 'pt':
        lang = 'pt-la';
        break;
      default:
        lang = 'en-us';
        break;
    }
    return lang;
  }

  getSystem(): { site: string; id: number } {
    const domain = this.winRef.getNativeWindow().location.hostname;
    if (domain.includes('lottokings') || domain.includes('lotosena')) {
      return { site: 'ltk', id: 5 };
    } else {
      return { site: 'wt', id: 1 };
    }
  }

  itsCristhmasHolidays(): boolean {
    const currentDate = new Date();
    const beginCristhmasDate = new Date(2021, 11, 1);
    const endCristhmasDate = new Date(2021, 11, 31);

    return currentDate >= beginCristhmasDate && currentDate <= endCristhmasDate ? true : false;
  }

  removeHttp(path: string): string {
    return path.replace('http://', '').replace('https://', '').replace('www.', '').replace('www5.', '').replace(/\/$/, '').split(':')[0];
  }

  getExpiredCache(time: number): any {
    let optionsFull: any;
    if (time >= 0) {
      const date = new Date();
      date.setDate(date.getDate() + time);
      optionsFull = { expires: date };
    } else {
      optionsFull = { expires: '-1d' };
    }
    return optionsFull;
  }
}
